import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

const FinTechCaseStudies = () => {
    return (
        <div className="section-py">
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12 mb-10">
                    <div className="lg:col-span-12">
                        <h2 className="text-primary_one mb-0">FinTech Case Studies</h2>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 mb-10">
                    <div className="lg:col-span-12">
                        <div className="border rounded-10 bg-grey lg:p-10 md:p-10 p-4 flex lg:flex-nowrap md:flex-nowrap flex-wrap gap-7 lg:gap-0 md:gap-0">
                            <div className="lg:pr-7 md:pr-7 pr-0">
                                <div className="flex items-center mb-3">
                                    <div className="pr-2">
                                        <Image
                                            src="/img/icons/ic-cost-delay.svg"
                                            alt="Cut Inventory Costs"
                                            title="Cut Inventory Costs"
                                            height={40}
                                            width={40}
                                        />
                                    </div>
                                    <p className="fs-xxl font-bold mb-0 text-primary_one">40%</p>
                                </div>
                                <p className="fs-md mb-0">
                                    Developed a digital wallet and neobanking solution for a startup,{' '}
                                    <span className="text-primary_one font-semibold">
                                        reducing transaction processing time by 40%.
                                    </span>
                                </p>
                            </div>
                            <div className="pr-0 pl-0 lg:pr-7 md:pr-7 lg:pl-7 md:pl-7 border-r-0 border-l-0 lg:border-r lg:border-l md:border-r md:border-l">
                                <div className="flex items-center mb-3">
                                    <div className="pr-2">
                                        <Image
                                            src="/img/icons/ic-accuracy.svg"
                                            alt="Increased Crop Yield"
                                            title="Increased Crop Yield"
                                            height={40}
                                            width={40}
                                        />
                                    </div>
                                    <p className="fs-xxl font-bold mb-0 text-primary_one">99.98%</p>
                                </div>

                                <p className="fs-md mb-0">
                                    Migrated legacy accounting software for a finance firm with{' '}
                                    <span className="text-primary_one font-semibold">
                                        99.98% data fidelity and zero downtime.
                                    </span>
                                </p>
                            </div>
                            <div className="pl-0 lg:pl-7 md:pl-7">
                                <div className="flex items-center mb-3">
                                    <div className="pr-2">
                                        <Image
                                            src="/img/icons/ic-accuracy.svg"
                                            alt="Drone Integration"
                                            title="Drone Integration"
                                            height={40}
                                            width={40}
                                        />
                                    </div>
                                    <p className="fs-xxl font-bold mb-0 text-primary_one">28%</p>
                                </div>

                                <p className="fs-md mb-0">
                                    Built a custom portfolio management tool with real-time BI dashboards,{' '}
                                    <span className="text-primary_one font-semibold">
                                        increasing asset manager productivity by 28%.
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-12">
                        <h2 className="mb-3 text-primary_one">Launch FinTech Software That Users Trust</h2>
                        <p className="mb-3">
                            Build secure, scalable financial apps that drive growth and meet compliance — without cutting corners.
                        </p>
                        <div>
                            <Link href="/contact-us" className="btn btn-primary">
                                {'Schedule Your Strategy Call'}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default FinTechCaseStudies;
